import { FulfillmentStatus } from 'src/utils/enums';

const isDeliveredOrShipped = (status: FulfillmentStatus): boolean => {
  return (
    status === FulfillmentStatus.DELIVERED ||
    status === FulfillmentStatus.SHIPPED
  );
};

export default isDeliveredOrShipped;
